import { render, staticRenderFns } from "./LearningMaterial.vue?vue&type=template&id=594978c2&"
import script from "./LearningMaterial.vue?vue&type=script&lang=js&"
export * from "./LearningMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports